function initializeInfiniteTagFeed() {
    const feed = document.querySelector('[data-infinite-feed]');
    const pagination = document.querySelector('.pagination');
    const status = document.querySelector('[data-infinite-status]');

    if (!feed || !pagination || !status || !('IntersectionObserver' in window)) {
        return;
    }

    const fallbackNextLink = pagination.querySelector('.older-posts');
    let nextPage = fallbackNextLink?.href;
    if (!nextPage) {
        return;
    }

    const loadedPages = new Set([window.location.href]);
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.className = 'h-px w-full';
    pagination.after(sentinel);
    pagination.hidden = true;

    const observer = new IntersectionObserver(async (entries) => {
        if (!entries.some((entry) => entry.isIntersecting) || !nextPage) {
            return;
        }

        observer.unobserve(sentinel);
        const pageToLoad = nextPage;

        if (loadedPages.has(pageToLoad)) {
            nextPage = null;
            sentinel.remove();
            return;
        }

        loadedPages.add(pageToLoad);
        feed.setAttribute('aria-busy', 'true');
        status.textContent = 'Loading more posts';

        try {
            const response = await fetch(pageToLoad, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });

            if (!response.ok) {
                throw new Error(`Unable to load posts (${response.status})`);
            }

            const page = new DOMParser().parseFromString(await response.text(), 'text/html');
            const newCards = [...page.querySelectorAll('[data-infinite-feed] [data-post-card]')];

            if (!newCards.length) {
                nextPage = null;
                sentinel.remove();
                status.textContent = 'All posts loaded';
                return;
            }

            newCards.forEach((card) => feed.append(card));
            const nextPath = page.querySelector('.pagination .older-posts')?.getAttribute('href');
            nextPage = nextPath ? new URL(nextPath, pageToLoad).href : null;
            status.textContent = `${newCards.length} more posts loaded`;

            if (nextPage) {
                fallbackNextLink.href = nextPage;
                observer.observe(sentinel);
            } else {
                sentinel.remove();
                status.textContent = 'All posts loaded';
            }
        } catch (error) {
            console.error(error);
            loadedPages.delete(pageToLoad);
            pagination.hidden = false;
            sentinel.remove();
            status.textContent = 'More posts could not be loaded automatically';
        } finally {
            feed.removeAttribute('aria-busy');
        }
    }, { rootMargin: '600px 0px' });

    observer.observe(sentinel);
}

document.addEventListener('DOMContentLoaded', initializeInfiniteTagFeed);
